import React from 'react'
import 'normalize.css/normalize.css'

const IndexPage = () => (
  <div>
    <div className="row width-container center-image">
      <video autoPlay muted width="100%" loop>
        <source
          src={
            'https://res.cloudinary.com/ditqglru2/video/upload/v1742848974/final_with_bg_bw7szt.mov'
          }
          type="video/mp4"
        />
      </video>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js